import { useContext } from 'react';
import { Divider, Stack, Text } from '@ltvco/refresh-lib/theme';
import { AppConstants } from '@ltvco/refresh-lib/ctx';
import { SidebarCard } from '../components';
import { SearchTypeItem } from '../../MainContent/PaymentSection/components';

export const SearchTypes = () => {
  const { images } = useContext(AppConstants);
  const extendedImages = images as any;

  return (
    <SidebarCard>
      <Text variant="h4" fontWeight={700} color="text.secondary">
        MULTIPLE WAYS TO SEARCH:
      </Text>
      <Divider sx={{ my: 1 }} />
      <Stack spacing={1} sx={{ mt: 1.25 }}>
        <SearchTypeItem>
          <img
            src={extendedImages.subscribePage.vinIcon}
            alt="vin"
            height={26}
          />
          <Text variant="body2">VIN Number</Text>
        </SearchTypeItem>
        <SearchTypeItem>
          <img
            src={extendedImages.subscribePage.plateIcon}
            alt="plate"
            height={26}
          />
          <Text variant="body2">License Plate</Text>
        </SearchTypeItem>
        <SearchTypeItem>
          <img
            src={extendedImages.subscribePage.ymmIcon}
            alt="ymm"
            height={16}
          />
          <Text variant="body2">Year, Make and Model</Text>
        </SearchTypeItem>
      </Stack>
    </SidebarCard>
  );
};
